import Icons from "./Icons";
import Card from "./Card";
import React, { forwardRef } from 'react';

function Input(props: any) {
    return (
        <div
            className={
                "loop-form-container d-flex flex-column w-100" +
                (props.containerClass ? props.containerClass : "")
            }
        >
            {props.label ? (
                <span className="loop-form-label">
                    {props.label}
                    {props.required ? (
                        <span className="loop-required-indicator">*</span>
                    ) : (
                        ""
                    )}
                </span>
            ) : null}
            <div className="loop-form-input-container">
                <input
                    placeholder={props.placeholder ? props.placeholder : ""}
                    type={props.type ? props.type : "text"}
                    className={
                        "loop-form-input " +
                        (props.className ? props.className : "")
                    }
                    value={props.value}
                    onChange={props.onChange}
                    disabled={props.disabled ? props.disabled : false}
                    required={props.required ? props.required : false}
                    onKeyPress={(ev: any) => {
                        if (ev.key === "Enter") {
                            ev.preventDefault();
                            if (props.onEnter) {
                                props.onEnter();
                            }
                        }
                    }}
                    onClick={props.onClick ? props.onClick : () => { }}
                    name={props?.emailForm ? "email" : null}
                />
                {props.clear ? (
                    <span
                        className="loop-form-input-clear-button"
                        onClick={(event: any) => {
                            let _event = { ...event };
                            _event.target.value = "";
                            props.onChange(_event);
                        }}
                    >
                        <Icons.Cancel />
                    </span>
                ) : null}
            </div>
        </div>
    );
}

function InputSingle(props: any) {
    return (
        <div
            className={
                "loop-form-container d-flex flex-column w-100" +
                (props.containerClass ? props.containerClass : "")
            }
        >
            {props.label ? (
                <strong className="loop-text-p1">
                    {props.label}
                    {props.required ? (
                        <span className="loop-required-indicator">*</span>
                    ) : (
                        ""
                    )}
                </strong>
            ) : null}
            <div className="loop-form-input-container">
                <input
                    placeholder={props.placeholder ? props.placeholder : ""}
                    type={props.type ? props.type : "text"}
                    className={
                        "loop-form-input-single " +
                        (props.className ? props.className : "")
                    }
                    value={props.value}
                    onChange={props.onChange}
                    disabled={props.disabled ? props.disabled : false}
                    required={props.required ? props.required : false}
                    onKeyPress={(ev: any) => {
                        if (ev.key === "Enter") {
                            ev.preventDefault();
                            if (props.onEnter) {
                                props.onEnter();
                            }
                        }
                    }}
                    onClick={props.onClick ? props.onClick : () => { }}
                />
                {props.clear ? (
                    <span
                        className="loop-form-input-clear-button"
                        onClick={(event: any) => {
                            let _event = { ...event };
                            _event.target.value = "";
                            props.onChange(_event);
                        }}
                    >
                        <Icons.Cancel />
                    </span>
                ) : null}
            </div>
        </div>
    );
}

function Select(props: any) {
    return (
        <div
            className={
                "loop-form-container d-flex flex-column w-100" +
                (props.className ? " " + props.className : "")
            }
        >
            {props.label ? (
                <span className="loop-form-label">{props.label}</span>
            ) : null}
            <select
                className="loop-form-select pe-4"
                value={props.value}
                onChange={props.onChange}
                disabled={props.disabled ? props.disabled : false}
            >
                {props.options.map((option: any, i: number) => {
                    return (
                        <option
                            key={i}
                            value={option.value}
                            disabled={option.disabled}
                        >
                            {option.label}
                        </option>
                    );
                })}
            </select>
        </div>
    );
}

function Choice(props: any) {
    return (
        <>
        <div
            className={
                "d-flex align-items-center my-1" +
                (props.className ? " " + props.className : "")
            }
        >
            <input
                id={props.value}
                disabled={props.disabled ? props.disabled : false}
                className="loop-form-choice-input"
                type="radio"
                value={props.value}
                checked={props.value === props.selectedValue}
                onChange={props.onChange}
            />
            {props.label ? (
                <label className="ms-2 flex-grow-1" htmlFor={props.value}>
                    {props.label}
                </label>
            ) : null}
        </div>
        {props?.additionalDetails ?
            <div className="my-1">
                <p className="loop-choice-additional-details">{props.additionalDetails}</p>
            </div>
        : null}
        </>
    );
}

function TextBox(props: any) {
    return (
        <div className="loop-form-container d-flex flex-column">
            {props.label ? (
                <span className="loop-form-label">{props.label}</span>
            ) : null}
            <textarea
                className={
                    "loop-form-input" + (props.className ? props.className : "")
                }
                value={props.value}
                onChange={props.onChange}
                placeholder={props.placeholder}
            />
        </div>
    );
}

function TextBoxSingle(props: any) {
    return (
        <div className="loop-form-container d-flex flex-column">
            {props.label ? (
                <span className="loop-text-p1">{props.label}</span>
            ) : null}
            <textarea
                rows={3}
                cols={20}
                className={
                    "loop-form-input-single" +
                    (props.className ? props.className : "")
                }
                value={props.value}
                onChange={props.onChange}
                placeholder={props.placeholder}
            />
        </div>
    );
}

function Checkbox(props: any) {
    return (
        <>
        <div
            className={
                "d-flex align-items-center my-1" +
                (props.className ? " " + props.className : "")
            }
        >
            <input
                id={props.id}
                type="checkbox"
                className="loop-form-checkbox-input"
                checked={props.value}
                onChange={props.onChange}
                disabled={props.disabled}
            />
            {props.label ? (
                <label className="m-0 ms-2 flex-grow-1" htmlFor={props.id}>
                    {props.label}
                </label>
            ) : null}
        </div>
        {props?.additionalDetails ?
            <div className="m-0 flex-grow-0">
                <p className="loop-checkbox-additional-details">{props.additionalDetails}</p>
            </div>
        : null}
        </>
    );
}

function CheckboxV2(props: any) {
    return (
        <>
        <div
            className={
                "d-flex align-items-center my-1" +
                (props.className ? " " + props.className : "")
            }
        >
            <input
                id={props.id}
                type="checkbox"
                className="loop-form-checkbox-v2-input"
                checked={props.value}
                onChange={props.onChange}
                disabled={props.disabled}
            />
            {props.label ? (
                <label className="m-0 ms-2 flex-grow-1" htmlFor={props.id}>
                    {props.label}
                </label>
            ) : null}
        </div>
        {props?.additionalDetails ?
            <div className="m-0 flex-grow-0">
                <p className="loop-checkbox-additional-details">{props.additionalDetails}</p>
            </div>
        : null}
        </>
    );
}

function ChoiceAccordion({
    value,
    selectedValue,
    onChange,
    label,
    disabled = undefined,
    body = null,
    className = "",
    cardClassName = "",
    ...props
}) {
    return (
        <Card className={className} cardClassName={cardClassName}>
            <Card.Header>
                <div className="d-flex align-items-center my-1">
                    <input
                        id={value}
                        disabled={disabled ? disabled : false}
                        className="loop-form-choice-input"
                        type="radio"
                        value={value}
                        checked={value === selectedValue}
                        onChange={onChange}
                    />
                    {label ? (
                        <label className="ms-2 flex-grow-1" htmlFor={value}>
                            {label}
                        </label>
                    ) : null}
                </div>
            </Card.Header>
            {body && value === selectedValue ? (
                <Card.Body>{body}</Card.Body>
            ) : null}
        </Card>
    );
}

function Slider({
    id = null,
    value,
    onChange,
    minValue,
    maxValue,
    className = "",
    step = 1,
    ...props
}) {
    return (
        <input
            id={id}
            type="range"
            min={minValue}
            max={maxValue}
            value={value}
            className={"loop-form-slider " + (className ? className : "")}
            onChange={(val) => {
                onChange(val.currentTarget.value);
            }}
            step={step}
        />
    );
}

const RefInput = forwardRef((props: any, ref: any) => {
    return (
        <div className={"loop-form-container d-flex flex-column w-100" + (props.containerClass ? props.containerClass : "")}>
            {props.label && (
                <span className="loop-form-label">
                    {props.label}
                    {props.required && <span className="loop-required-indicator">*</span>}
                </span>
            )}
            <div className="loop-form-input-container">
                <input
                    ref={ref}
                    placeholder={props.placeholder || ""}
                    type={props.type || "text"}
                    className={"loop-form-input " + (props.className || "")}
                    value={props.value}
                    onChange={props.onChange}
                    disabled={props.disabled || false}
                    required={props.required || false}
                    onKeyPress={(ev) => {
                        if (ev.key === "Enter") {
                            ev.preventDefault();
                            props.onEnter?.();
                        }
                    }}
                    onClick={props.onClick || (() => { })}
                />
                {props.clear && (
                    <span
                        className="loop-form-input-clear-button"
                        onClick={(event: any) => {
                            let _event = { ...event };
                            _event.target.value = "";
                            props.onChange(_event);
                        }}
                    >
                        <Icons.Cancel />
                    </span>
                )}
            </div>
        </div>
    );
});

const InputIncrement = (props: any) => {
    return (
        <div
            className={
                "loop-form-container d-flex flex-column w-100" +
                (props.containerClass ? props.containerClass : "")
            }
        >
            {props.label ? (
                <span className="loop-form-label">
                    {props.label}
                    {props.required ? (
                        <span className="loop-required-indicator">*</span>
                    ) : (
                        ""
                    )}
                </span>
            ) : null}
            <div className="loop-form-input-container">
                <input
                    placeholder={props.placeholder ? props.placeholder : ""}
                    type={props.type ? props.type : "text"}
                    className={
                        "loop-form-increment " +
                        (props.className ? props.className : "")
                    }
                    value={props.value}
                    onChange={props.onChange}
                    disabled={props.disabled ? props.disabled : false}
                    required={props.required ? props.required : false}
                    onKeyPress={(ev: any) => {
                        if (ev.key === "Enter") {
                            ev.preventDefault();
                            if (props.onEnter) {
                                props.onEnter();
                            }
                        }
                    }}
                    onClick={props.onClick ? props.onClick : () => { }}
                />
                {props.clear ? (
                    <span
                        className="loop-form-input-clear-button"
                        onClick={(event: any) => {
                            let _event = { ...event };
                            _event.target.value = "";
                            props.onChange(_event);
                        }}
                    >
                        <Icons.Cancel />
                    </span>
                ) : null}
            </div>
        </div>
    );
};  

export default Object.assign(
    {},
    {
        Input: Input,
        Select: Select,
        Choice: Choice,
        TextBox: TextBox,
        Checkbox: Checkbox,
        ChoiceAccordion: ChoiceAccordion,
        TextBoxSingle: TextBoxSingle,
        InputSingle: InputSingle,
        Slider: Slider,
        InputIncrement: InputIncrement,
        RefInput: RefInput,
        CheckboxV2: CheckboxV2,
    },
);
